export const MIN_PHOTO_PX = 512;

export function checkImageFile(file) {
    return new Promise((resolve) => {
        if (!file || !String(file.type || "").startsWith("image/")) {
            resolve({ ok: false, reason: "type" });
            return;
        }
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            const w = img.naturalWidth;
            const h = img.naturalHeight;
            if (Math.min(w, h) < MIN_PHOTO_PX) resolve({ ok: false, reason: "small", w, h });
            else resolve({ ok: true, w, h });
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            resolve({ ok: false, reason: "corrupt" });
        };
        img.src = url;
    });
}

export function checkMessage(res, name = "") {
    const p = name ? `${name}: ` : "";
    if (res.reason === "small") return `${p}foto te klein (${res.w}×${res.h}px) — minimaal ${MIN_PHOTO_PX}px nodig voor een goed AI-resultaat`;
    return `${p}beschadigd of geen geldige afbeelding — upload een JPG of PNG`;
}
